import { FC, useRef } from 'react';

import { TooltipHover } from '@hh.ru/magritte-ui';
import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

export const TableHeaderTooltip: FC<{ tooltipText?: string }> = ({ tooltipText }) => {
    const activatorRef = useRef<HTMLDivElement>(null);

    if (!tooltipText) {
        return null;
    }

    return (
        <>
            <QuestionCircleOutlinedSize16 initialColor="secondary" ref={activatorRef} />
            <TooltipHover maxWidth={320} activatorRef={activatorRef} placement="top-center">
                {tooltipText}
            </TooltipHover>
        </>
    );
};
